var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import get from 'lodash.get';
import { useMemo } from 'react';
import useDesign from '../../../../../hooks/useDesign';
import { Body } from './components/Body';
import { Footer } from './components/Footer';
import { parse } from '../../utils';
import { Header } from './components/Header';
import { Card } from './styles';
export var Incentive = function (_a) {
    var design = _a.design, values = _a.values;
    var _b = useDesign(design), _c = _b.components, header = _c.header, body = _c.body, footer = _c.footer, components = __rest(_c, ["header", "body", "footer"]), _d = _b.config, translations = _d.translations, css = _d.css, config = __rest(_d, ["translations", "css"]), schema = _b.schema;
    var _e = useMemo(function () { return parse(values, config); }, [values]), incentiveUrl = _e.incentiveUrl, parsedValues = __rest(_e, ["incentiveUrl"]);
    var eligibility = values.eligibility;
    var cardCss = get(css, eligibility);
    return (_jsxs(Card, __assign({ "data-design": design, schema: schema, css: cardCss }, { children: [_jsx(Header, { design: header, values: parsedValues, translations: translations }), _jsx(Body, { design: body, translations: translations, values: parsedValues, components: components }), _jsx(Footer, { design: footer, translations: translations, to: incentiveUrl })] })));
};
Incentive.displayName = 'Incentive';
